import { FeishuContext2d } from "../feishu";

export class TTContext2d extends FeishuContext2d {}

TTContext2d.env = "tt";
//# sourceMappingURL=context.js.map
